import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, EMPTY, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SocoHttpService } from '@soco/http';
import { SocoConfigurationService } from '@soco/configuration';
import { ApiResult } from '@soco/core';
import { url } from 'inspector';
import { CoolEmailSettings } from './coolEmail-entities';
import { DBTraceLog } from '../dbTraceLog/dbTraceLog-entities';
import { string } from 'prop-types';


@Injectable()
export class CoolEmailService {

    public baseUrl = '/CoolEmail/';
    public appDataBaseUrl = '/AppData/';
    public coolEmailSettings: CoolEmailSettings;

    constructor(private http: SocoHttpService, private ngHttp: HttpClient, private config: SocoConfigurationService) { }

    sendEmail(coolEmailSettings: CoolEmailSettings) {

        return this.http.post<any>({
            url: this.baseUrl + 'SendEmail',
            data: coolEmailSettings,
            //alertId: alertId,
            shouldIgnoreInvalidResult: true,
            pleaseWaitTimeoutDuration: 500
        });
    }
        
}